<nb-card>
  <nb-card-header>
    <nb-select
      outline
      size="small"
      [status]="
        feedback.category == 'Góp ý'
          ? 'success'
          : feedback.category == 'Báo lỗi'
          ? 'warning'
          : 'info'
      "
      placeholder="Chọn trạng thái"
      [(ngModel)]="feedback.category"
    >
      <nb-option value="Góp ý">Góp ý</nb-option>
      <nb-option value="Báo lỗi">Báo lỗi</nb-option>
      <nb-option value="Yêu cầu">Yêu cầu</nb-option>
    </nb-select>

    {{ mode === "new" ? "" : feedback.title }}

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <form [formGroup]="diaForm">
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Tiêu đề</h6>
          <p class="text-hint">Ngắn gọn, rõ ràng nêu lên chủ đề cần chia sẻ</p>
        </div>

        <input
          type="text"
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [(ngModel)]="feedback.title"
        />
      </div>
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Mô tả</h6>
          <p class="text-hint">
            Tóm tắt nội dung ngắn gọn, giúp người đọc có thể nắm nhanh được bài
            viết
          </p>
        </div>

        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          placeholder="Nhập mô tả"
          class="form-control"
          formControlName="description"
          [(ngModel)]="feedback.description"
        ></textarea>
      </div>
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">
            Nội dung chi tiết
            <nb-select
              outline
              shape="round"
              size="small"
              status="info"
              formControlName="sourceType"
              [(ngModel)]="feedback.sourceType"
            >
              <nb-option value="document">Tài liệu</nb-option>
              <nb-option value="video">Video</nb-option>
              <nb-option value="images">Hình ảnh</nb-option>
            </nb-select>
          </h6>
        </div>

        <div *ngIf="feedback.sourceType == 'video'" class="form-group">
          <ngx-view-video [url]="feedback.videoUrl"></ngx-view-video>
          <div class="form-group">
            <label class="label">Đường dẫn URL</label>
            <input
              nbInput
              fullWidth
              formControlName="url"
              placeholder="Nhập liên kết"
              class="form-control"
              [(ngModel)]="feedback.videoUrl"
            />
          </div>
        </div>

        <div *ngIf="feedback.sourceType == 'images'">
          <nb-card>
            <nb-card-header>
              <button
                nbButton
                outline
                fullWidth
                status="info"
                size="tiny"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="openGallery()"
              >
                <nb-icon icon="image-outline"></nb-icon>
                Chọn hình ảnh
              </button>
            </nb-card-header>
            <nb-card-body class="container">
              <div class="row">
                <div
                  class="column"
                  *ngFor="let item of imagesUrl; let i = index"
                >
                  <button
                    type="submit"
                    nbButton
                    outline
                    fullWidth
                    status="danger"
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="deleteImage(item)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                  <img [src]="item" style="width: 100%" />
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <ngx-editor-document
          *ngIf="feedback.sourceType == 'document'"
          formControlName="content"
          [(ngModel)]="feedback.content"
        ></ngx-editor-document>
      </div>

      <div class="form-group">
        <label class="label">Nhập phân loại ( Tag)</label>
        <nb-tag-list (tagRemove)="onTagRemove($event)">
          <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
          <input type="text" nbTagInput (tagAdd)="onTagAdd($event)" fullWidth />
        </nb-tag-list>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <!-- <nb-select
      hero
      size="small"
      [status]="status == '1' ? 'success' : status == '0' ? 'info' : 'warning'"
      placeholder="Chọn trạng thái"
      [(ngModel)]="status"
    >
      <nb-option value="1">Xuất bản</nb-option>
      <nb-option value="0">Đang thực hiện</nb-option>
    </nb-select> -->
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
